import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

export interface MarketplaceOption {
  value: string;
  count: number;
}

/**
 * Distinct marketplace channels present in orders, for the marketplace filter dropdown.
 */
export function useOrderMarketplaces() {
  return useQuery({
    queryKey: ["order-marketplaces"],
    queryFn: async (): Promise<MarketplaceOption[]> => {
      const { data, error } = await apiClient.GET("/v1/orders/marketplaces", {});
      if (error) throw error;
      return data?.data ?? [];
    },
  });
}
